import { render, staticRenderFns } from "./form-answers.pug?vue&type=template&id=35257d56&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./form-answers.scss?vue&type=style&index=0&id=35257d56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35257d56",
  null
  
)

export default component.exports